/**
 * Events Plugin - Main Entry Point
 * WordPress Block Standard: Single build file for all blocks
 * Registers all blocks using block.json metadata
 */

// Import all block registration functions
import './events-grid';
import './event-item';
import './event-date-badge';
